import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { DeviceSimple } from 'core/models/deviceModel';
import { PatientBase, PatientModelBase } from 'core/models/patientModelBase';
import { Sensor } from './sensorModal';

dayjs.extend(utc);

export interface PatientRouteParams {
  id: string;
  studyId: string;
  eventId: string;
}

export interface ThirdPartyNotification {
  email?: string;
  phone?: string;
  note?: string;
}

interface Studies {
  id: string;
  name: string;
}

export interface ActiveSession {
  id: string;
  active: boolean;
  start?: string | null;
  end?: string | null;
}

export interface Patient extends PatientBase {
  birthDate: string | Dayjs | undefined;
  birthDateStr?: string | Dayjs | undefined;
  physician?: any;
  isOpenPrescribingPhysician: boolean;
  prescribingPhysicianName: string;
  monitoringProtocolId: any;
  sensors: Sensor[];
  devices: DeviceSimple[];
  codes?: any;
  studiesList?: Studies[];
  deviceMismatch: boolean;
  thirdPartyNotification?: ThirdPartyNotification[];
  timeZoneOffset: number;
  timeZoneName: string;
  isRpm: boolean;
  rpmGroupIds?: string[];
  deviceTypeCodes?: number[];
}

export interface RawPatient {
  id: string;
  activeSession: ActiveSession;
  firstName: string;
  lastName: string;
  birthDate: string;
  birthDateStr: string;
  physician: any | string;
  physicianId: any | string;
  isOpenPrescribingPhysician: boolean;
  prescribingPhysicianName: string;
  monitoringProtocol: any | string;
  devices: DeviceSimple[];
  sensors: Sensor[];
  codes?: any;
  clinic?: string;
  subjectId: string;
  siteName?: string;
  studiesList?: Studies[];
  deviceMismatch: boolean;
  thirdPartyNotificationEmails?: any;
  timeZoneOffset: number;
  timeZoneName: string;
  lastDataAt: string;
  createdAt: string;
  isRpm: boolean;
  rpmGroupIds?: string[];
  name?: string;
  deviceTypeCodes?: number[];
  sessionPlanStartedAt?: string;
  sessionPlanEndedAt?: string;
}

export const PATIENT_TITLE = 'Patient';

export class PatientModel extends PatientModelBase implements Patient {
  birthDate: string | Dayjs | undefined;

  birthDateStr?: string | Dayjs | undefined;

  physicianId?: any;

  physician?: any;

  isOpenPrescribingPhysician: boolean;

  prescribingPhysicianName: string;

  monitoringProtocol?: any;

  monitoringProtocolId: any;

  sensors: Sensor[];

  devices: DeviceSimple[];

  activeSession?: ActiveSession;

  codes?: any;

  clinic?: string;

  subjectId?: string;

  siteName?: string;

  studiesList?: Studies[];

  deviceMismatch: boolean;

  thirdPartyNotificationEmails?: any;

  timeZoneOffset: number;

  timeZoneName: string;

  lastDataAt?: string;

  createdAt?: string;

  isRpm: boolean;

  rpmGroupIds?: string[];

  deviceTypeCodes?: number[];

  sessionPlanStartedAt?: string;

  sessionPlanEndedAt?: string;

  constructor(data: RawPatient) {
    super(data);
    this.clinic = data.clinic;
    this.id = data.id;
    this.birthDate =
      data.birthDate == null || data.birthDate === ''
        ? ''
        : dayjs(data.birthDate).utc();
    this.birthDateStr = data.birthDateStr;
    this.subjectId = data.subjectId;
    this.sensors = data.sensors;
    this.devices = data.devices;
    this.physician = data.physician;
    this.isOpenPrescribingPhysician = data.isOpenPrescribingPhysician;
    this.prescribingPhysicianName = data.prescribingPhysicianName;
    this.monitoringProtocolId = data.monitoringProtocol?.id;

    this.activeSession = data.activeSession;

    this.codes = data.codes;

    this.siteName = data.siteName;

    this.studiesList = data.studiesList;

    this.monitoringProtocol = data.monitoringProtocol;

    this.deviceMismatch = data.deviceMismatch;

    this.thirdPartyNotificationEmails = data.thirdPartyNotificationEmails;

    this.timeZoneOffset = data.timeZoneOffset;

    this.timeZoneName = data.timeZoneName;

    this.lastDataAt = data.lastDataAt;
    this.createdAt = data.createdAt;
    this.sessionPlanStartedAt = data.sessionPlanStartedAt;
    this.sessionPlanEndedAt = data.sessionPlanEndedAt;

    this.isRpm = data.isRpm;

    this.rpmGroupIds = data.rpmGroupIds;
    this.deviceTypeCodes = data.deviceTypeCodes;
  }
}
